export const ACT_USERSETTINGS = 'userSettings';

export const GET_USERSETTINGS = 'userSettingsGet';

export const MUT_USERSETTINGS = 'addUserSettings';
